import { apiService } from './apiService';

export type GetNumberOfCorporateUsersResponse = {
  corporateAccounts: {
    used: number;
    available: number;
  };
};

export const corporateUsersService = {
  async getNumberOfCorporateUsers() {
    const resp = await apiService.get<GetNumberOfCorporateUsersResponse>(
      'api/coach/corporate-entity/limits',
    );

    return resp.data;
  },
};
